<template>
  <div class="card-component" :class="color">
    <div class="title">{{data.title}}</div>
    <div class="text">{{data.text}}</div>
    <ul v-if="data.features">
      <li v-for="feature in data.features">{{feature}}</li>
    </ul>
    <div class="asterix" v-if="data.asterix">{{data.asterix}}</div>
  </div>
</template>
<script>
  export default {
    name: 'card-component',
    props: {
      color: String,
      data: Object,
    },
    methods: {
    },
  }
</script>
<style scope lang="scss">
  .card-component {
    border-radius: 20px;
    padding: 15px;
    margin: 5px;
    color: $color-11;
    &.green {
      background-color: $color-4;
    }
    &.yellow {
      background-color: $color-5;
    }
    .title {
      font-size: 30px;
      font-weight: bold;
    }
    ul {
      list-style: disc;
      padding-left: 20px;
    }
    .text {
      margin: 5px 0;
    }
    .asterix {
      padding-left: 10px;
      position: relative;
      font-size: 14px;
      &::before {
        position: absolute;
        content: '*';
        left: 0px;
        top: 2px;
      }
    }
  }
</style>